export default __webpack_public_path__ + "static/media/flutter.a57bab14.png";